var resetEl = document.querySelector('.quiz-submit.reset');
if (resetEl != null) {
    resetEl.addEventListener('click', function(event) {
        if(!confirm('This will erase your previous score, do you want to continue?')) {
            event.preventDefault();
        }
    });
}

var certEl = document.querySelector('.sensei-certificate-link');
if (certEl != null) {
    certEl.target = "_blank";
}

var certLinkEl = document.querySelector('a[title="View Certificate"]');
if (certLinkEl != null) {
    certLinkEl.target = "_blank";
}

var senseiSidebar = document.querySelector('.widget_sensei_course_progress header');
if (senseiSidebar) {
    senseiSidebar.innerHTML = senseiSidebar.innerHTML + '<div class="text-baseline" style="padding-top: .5rem; padding-bottom: .5rem">Lesson Navigation </div>';
}

var senseiStartLesson = document.querySelector('.single-course .course-progress-lessons .course-progress-lesson.not-completed a');
if (senseiStartLesson) {
    senseiStartLesson.innerHTML = senseiStartLesson.innerHTML + '<br><div style="background: #63a95f; color: #ffffff; font-weight: 400; font-size: 14px; padding: .15rem .5rem; border-radius: .2rem; display: inline-block; margin-top: .2rem;">Start Lesson</div>';
}

jQuery(function($){

    $('#mobile-menu-button').click(function(){
        $('#mobile-menu').toggleClass('hidden');
        $(this).find('svg').toggleClass('hidden').toggleClass('block');
    });

});

